import { all, takeLatest } from 'redux-saga/effects'
import store from '../../store'
import { actions } from './PackTraces.slice'
import { paginate } from './PackTraces.thunk'

function paginateTraces () {
  store.dispatch(paginate() as any)
}

export default function * effects () {
  yield all([
    takeLatest(actions.replaceLimit, paginateTraces),
    takeLatest(actions.replacePage, paginateTraces),
    takeLatest(actions.replaceSearch, paginateTraces)
  ])
}
